import { createContext, useContext, useState } from "react";

interface MenuState {
  isOpen: boolean;
  [label: string]: boolean;
}

export interface MenuContextType {
  menu: MenuState;
  toggleMenu: () => void;
  setSubMenuOpen: (menuId: string, isOpen: boolean) => void;
}

interface MenuProviderProps {
  children: React.ReactNode;
  initValue?: Partial<MenuState>;
}


const MenuContext = createContext<MenuContextType>({} as MenuContextType);


export const MenuProvider = ({ children, initValue }: MenuProviderProps) => {
  const [menu, setMenu] = useState<MenuState>({
    isOpen: true,
    ...initValue,
  });

  const toggleMenu = () => {
    setMenu(prev => ({ ...prev, isOpen: !prev.isOpen }));
  };

  const setSubMenuOpen = (menuId: string, isOpen: boolean) => {
    setMenu(prev => ({ ...prev, [menuId]: isOpen }));
  };

  return <MenuContext.Provider value={{ menu, toggleMenu, setSubMenuOpen }}>{children}</MenuContext.Provider>;
};

export const useMenuContext = () => useContext(MenuContext);
